import { Grid } from "@mui/material";
import { ReactElement } from "react";
import AddButton from "../../common/components/functional/addButton/AddButton";
import { AccessRightChecks } from "../user/accessRightChecks";

type Props = {
  children: ReactElement;
  onClick?: () => void;
  buttonLabel?: string;
  buttonDisabled?: boolean;
  accessRightChecks?: AccessRightChecks;
};

// TODO: add empty state
const CardsList = ({
  onClick,
  buttonLabel,
  buttonDisabled,
  children,
  accessRightChecks,
}: Props) => {
  return (
    <Grid item>
      {onClick && buttonLabel && (
        <AddButton
          accessRightChecks={accessRightChecks}
          sx={{
            marginLeft: "1rem",
            marginBottom: "1rem",
            height: "40px",
            borderRadius: "20px",
          }}
          disabled={buttonDisabled}
          variant="contained"
          label={buttonLabel}
          onClick={() => onClick()}
        />
      )}
      {children}
    </Grid>
  );
};

export default CardsList;
